import {
  IDeliveryOption,
  IIdValuePairResponse,
  IWarehousePayload,
} from "../interfaces/Index";
import { DeliveredBy } from "../interfaces/tourCreation.interface";

export const normalizeTourAndRiderCheckResponse = (res: string[]) => {
  const result =
    res.length > 0
      ? res.map((item) => {
          return {
            value: "Already Assigned",
            label: "Already Assigned",
          };
        })
      : [];
  return result;
};

export const normalize3plCSVUploadPayload = (
  warehouseId: string,
  deliveredBy: string,
  file: any
) => {
  let formData = new FormData();
  formData.append("warehouseId", warehouseId);
  formData.append("deliveredBy", deliveredBy);
  formData.append("tourCsv", file);
  return formData;
};

export const normalizeWarehouseResponseForDropdown = (
  warehouses: IWarehousePayload[]
) => {
  return warehouses.map((warehouse: IWarehousePayload) => {
    return {
      ...warehouse,
      key: warehouse.id,
      title: warehouse.name,
      label: warehouse.name,
    };
  });
};

export const normalizeSubTypeForDropdown = (type: string): IDeliveryOption => ({
  id: type,
  key: type,
  title: type,
  label: type,
});

export const normalizeSubTypeResponseForDropdown = (types: string[]) => {
  return types.map(normalizeSubTypeForDropdown);
};
